'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _query = require('utilities/query');

var _loadingAdminList = require('./loading-admin-list.html');

var _loadingAdminList2 = _interopRequireDefault(_loadingAdminList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

exports.default = {
  templateUrl: _loadingAdminList2.default,
  transclude: {
    actionButtons: '?actionButtons'
  },
  bindings: {
    administrations: '<',
    selectedAdministrations: '<',
    unitsDisplay: '<',
    unitPerContainer: '<',
    locked: '<',
    showHeader: '<'
  },
  controller: function () {
    function LoadingAdminListComponent(EventEmitter) {
      'ngInject';

      _classCallCheck(this, LoadingAdminListComponent);

      Object.assign(this, { EventEmitter: EventEmitter });
    }

    _createClass(LoadingAdminListComponent, [{
      key: '$onInit',
      value: function $onInit() {
        this.query = (0, _query.getQuery)();
        this.limitOptions = (0, _query.getLimitOptions)();
        this.administrations = this.administrations.filter(function (a) {
          return a.Isloading === true;
        });
      }
    }, {
      key: '$onChanges',
      value: function $onChanges() {
        this.administrations = this.administrations.filter(function (a) {
          return a.Isloading === true;
        });
      }
    }]);

    return LoadingAdminListComponent;
  }()
};


// WEBPACK FOOTER //
// ./components/app/product/loading-admin-list/loading-admin-list.component.js